// All these functions were in the employees collections and they made no sense
// there.
import filter from 'lodash/filter'

import { Employees } from 'modules/employees/store/collections/employees'
import type TimeoffPolicy from 'modules/timeoff/store/models/TimeoffPolicy/Policy'

export const timeoffPolicyEmployees = (timeoffPolicy: TimeoffPolicy, employees: Employees) => {
  return employees.filter({
    timeoff_policy_id: timeoffPolicy.attributes.id,
  })
}

export const timeoffPolicyActiveEmployees = (
  timeoffPolicy: TimeoffPolicy,
  employees: Employees
) => {
  return filter(
    employees.active,
    (employee) => employee.attributes.timeoff_policy_id === timeoffPolicy.attributes.id
  )
}
